import React from 'react'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import StandardModalContent from '../StandardModalContent/StandardModalContent.jsx'

class RefreshAlertModal extends React.PureComponent {
  state = {
    timer: null,
    refreshInProgress: true
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let timeout = prevState.timeout
    if (prevState.refreshInProgress && !nextProps.auth.refreshInProgress) {
      timeout = setTimeout(nextProps.clearModal(), 2000)
    }
    return { timeout, refreshInProgress: nextProps.auth.refreshInProgress }
  }
  componentWillUnmount() {
    if (this.state.timeout != null) {
      clearTimeout(this.state.timeout)
    }
  }
  render() {
    return (
      <StandardModalContent
        messageContent={
          <React.Fragment>
            <div>
              Contact with the API is taking longer than expected. This message
              will automatically clear when contact is reastablished.
            </div>
            <div>
              {this.props.auth.refreshInProgress
                ? 'Connecting...'
                : 'Connection established!'}
            </div>
            <div>
              {this.props.auth.refreshInProgress ? (
                <FontAwesomeIcon
                  icon={['fas', 'cog']}
                  spin
                  size="3x"
                  fixedWidth
                />
              ) : (
                <FontAwesomeIcon
                  icon={['fas', 'check-circule']}
                  style={{ color: 'green' }}
                  size="3x"
                  fixedWidth
                />
              )}
            </div>
          </React.Fragment>
        }
        okHandler={() => null}
        okText={'OK'}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps)(RefreshAlertModal)
